import {
    GET_AMAZON_PROFIT_LOADING,
    GET_AMAZON_PROFIT_SUCCESS

} from '../actions/ProfitAction';

const initialState = {
    amazon: {
        profitData: null,
        isLoading: true,
    },
    shopify: {
        profitData: null,
        isLoading: true,
    },
    wholesale: {
        profitData: null,
        isLoading: true,
    }
};

const ProfitReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_AMAZON_PROFIT_SUCCESS:
            return {
                ...state, [action.vendor]: { profitData: action.data, isLoading: false }
            };

        case GET_AMAZON_PROFIT_LOADING:
            return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default ProfitReducer;
